<template>
  <section class="bg-white antialiased">
    <div class="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
      <div class="flex flex-col items-center">

        <img 
          src="images/Container.png" 
          alt="Banner: Cadastre-se agora e tenha descontos exclusivos" 
          class="w-full"
        />

        <div class="mt-16 text-center">
          <h3 class="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Clique no botão e faça já o seu<br />diagnóstico gratuito
          </h3>
        </div>

        <div class="mt-10">
          <a
            href="#"
            class="inline-flex items-center justify-center gap-3 rounded-full bg-orange-500 px-6 py-4 text-base font-bold text-white shadow-lg transition hover:bg-orange-600 hover:scale-105"
          >
            <span>Quero aumentar as minhas vendas agora</span>
            <svg width="25" height="12" viewBox="0 0 25 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.4351 0.203125L18.4141 1.22412L21.9326 4.74268H0V6.25732H21.9326L18.4141 9.77588L19.4351 10.7969L24.7324 5.5L19.4351 0.203125Z" fill="white"/>
              <path d="M12.4351 0.203125L11.4141 1.22412L14.9326 4.74268H6V6.25732H14.9326L11.4141 9.77588L12.4351 10.7969L17.7324 5.5L12.4351 0.203125Z" fill="white" fill-opacity="0.5"/>
              <path d="M5.43506 0.203125L4.41406 1.22412L7.93262 4.74268H0V6.25732H7.93262L4.41406 9.77588L5.43506 10.7969L10.7324 5.5L5.43506 0.203125Z" fill="white" fill-opacity="0.2"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// SCRIPT MODIFICADO: O array 'features' e o 'ref' foram removidos por não serem mais necessários.
// O script agora está vazio, mas mantemos o bloco para consistência do padrão Vue 3.
</script>

<style scoped>
/* Adicione estilos personalizados aqui, se necessário. */
</style>